// Product Slider - Thumbnails

document.addEventListener("DOMContentLoaded", function () {
  // Target the product template
  let produt_img = document.querySelector('#product-template--wrapper.enhanced-product-template #main-carousel');
  let produt_thump_img = document.querySelector('#product-template--wrapper.enhanced-product-template #thumbnail-carousel');

  if (produt_img && produt_thump_img) {
    // Use settings for enhanced product template
    var main = new Splide(produt_img, {
      rewind: false,
      pagination: false,
      arrows: false,
       breakpoints: {
        767: {
          padding: '2rem',
        },
      },
      
    });

    var thumbnails = new Splide(produt_thump_img, {
      gap: 10,
      perPage: 6,
      rewind: false,
      pagination: false,
      isNavigation: true,
      arrows: true,
      focus: false,
      classes: {
        arrows: 'splide__arrows main-arrows',
        arrow : 'splide__arrow',
      },
      focus: 'start',
      breakpoints: {
        767: {
          perPage: 5.5,
          arrows: false
        },
      },
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  } else {
    // Default fallback for other templates
    var main = new Splide('#main-carousel', {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: true,
    });

    var thumbnails = new Splide('#thumbnail-carousel', {
      gap: 10,
      perPage: 4,
      rewind: true,
      pagination: false,
      isNavigation: true,
      arrows: false,
      focus: 'center',
      breakpoints: {
        600: {
          perPage: 3,
        },
      },
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }
});

// Slider Image Change when Colour Swatch has been clicked

document.querySelectorAll('.color-swatch input').forEach((c) => {
  c.addEventListener('click', () => {
    let img = c.getAttribute('img');
    document.querySelectorAll('#thumbnail-carousel-track li').forEach((t) => {
        let slide = t;
        slide_color = t.getAttribute('color');
        if (slide_color === img) {
          slide.click();      
        }
    });
  });
});

// MAKE ONE FOR THE DROP DOWN TOO AND DEFAULT TO SCROLL DOWN TO IT